import { config, vueConfig, setThemeConfig, setConfigValue } from '@/config'
import themeConfig from '../config'
import svgs from '../svg'
import '@/default'

setThemeConfig(themeConfig)
Object.assign(vueConfig.registerGlobalsComponentMap, svgs)
